<template>

</template>

<script>
    export default {
        props: {
            message: {
                type: String
            }
        },
        created() {
            this.$swal({
                text: `${this.message}`,
                type: 'success',
                toast: true,
                position: 'top',
                timer: 1500,
                showConfirmButton: false,
                allowEscapeKey: false,
                onClose: () => {
                    this.$store.commit('CLEAR_SUCCESS')
                }
            })
        }        
    }    
</script>
